import React from 'react';
import PropTypes from 'prop-types';

import TaskUsersList from "./task-users-list";
import ProjectUsersList from "./project-users-list";

import Classes from 'classnames';

export default function UsersInList(props) {
    let res;
    switch (props.type) {
        case 'task':    res = <TaskUsersList item={props.item}/>; break;
        case 'project': res = <ProjectUsersList item={props.item}/>; break;
    }

    const classes = Classes("gd-field-users", "list", props.className);

    return <div className={classes}>{res}</div>;
}

UsersInList.propTypes = {
    item: PropTypes.object,
    type: PropTypes.oneOf(['task','project'])
};